@if (!isContainer) {
<sidebar-menu-item [class.collapsed]="isCollapsed" [isCollapsed]="isCollapsed" [item]="item"> </sidebar-menu-item>
} @if (isContainer) {
<sidebar-menu-container [class.collapsed]="isCollapsed" [item]="item" [isCollapsed]="isCollapsed">
</sidebar-menu-container>
}
